module.exports = __webpack_public_path__ + "static/img/zhuapaijilu.5ab2a8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/zhuapaijilu.png
// module id = Tip4
// module chunks = 24